import React, { useEffect, useRef } from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import { Checkbox, TableRow, TableCell, Tooltip } from '@material-ui/core';
import { ErrorIcon, TimesIcon } from '../../../../icons';

export const GUEST_FIELD_ERROR_KEY = 'GUEST_FIELD_OPERATION_ERROR';

const fieldTypes = [
    {
        type: 'string',
        name: 'Text'
    },
    {
        type: 'number',
        name: 'Number'
    },
    {
        type: 'boolean',
        name: 'True/False'
    },
    {
        type: 'hotel',
        name: 'Hotel'
    },
    {
        type: 'date',
        name: 'Date'
    },
    {
        type: 'weight',
        name: 'Weight'
    },
    {
        type: 'height',
        name: 'Height'
    }
];

const GuestField = props => {
    const { guestField, setGuestField, removeGuestField, setErrors, errors } = props;
    const { disabled, name, type, agentOnly, required, useForRegistration } = guestField;

    const nameElement = useRef(null);

    useEffect(() => {
        if (name === '') {
            nameElement.current.focus();
        }
    }, [name, nameElement]);

    const [boolOperationError, setBoolOperationError] = React.useState(false);

    useEffect(() => {
        const isBoolOperationError = required && !useForRegistration;
        setBoolOperationError(isBoolOperationError);
        if (isBoolOperationError) {
            setErrors({
                ...errors,
                [guestField.id]: GUEST_FIELD_ERROR_KEY
            });
        }
    }, [required, useForRegistration, setErrors, errors, guestField.id]);

    const updateGuestField = (field, value) => {
        // If the field name is required and the value is true,
        // we should set the useForRegistration field to true as well
        if (field === 'required' && value === true) {
            setGuestField({
                ...guestField,
                useForRegistration: true,
                required: true
            });
        } else {
            setGuestField({
                ...guestField,
                [field]: value
            });
        }
    };

    // If the field is required, we should not allow it to be optional during registration
    const isFieldRequired = required && useForRegistration;

    return (
        <>
            <TableRow>
                <TableCell>
                    {!disabled && (
                        <IconButton onClick={() => removeGuestField(guestField)}>
                            <TimesIcon />
                        </IconButton>
                    )}
                </TableCell>
                <TableCell>
                    <TextField
                        placeholder="Name of booking field"
                        inputRef={nameElement}
                        disabled={disabled}
                        value={name}
                        onChange={event => updateGuestField('name', event.target.value)}
                        fullWidth
                    />
                </TableCell>
                <TableCell>
                    <Select
                        disabled={disabled}
                        value={type}
                        onChange={event => updateGuestField('type', event.target.value)}
                    >
                        {fieldTypes.map(fieldType => (
                            <MenuItem key={fieldType.name} value={fieldType.type}>
                                {fieldType.name}
                            </MenuItem>
                        ))}
                    </Select>
                </TableCell>
                <TableCell>
                    <Checkbox
                        disabled={disabled}
                        checked={!!agentOnly}
                        onChange={() => updateGuestField('agentOnly', !agentOnly)}
                    />
                </TableCell>
                <TableCell>
                    <Checkbox
                        disabled={disabled}
                        checked={!!required}
                        onChange={() => updateGuestField('required', !required)}
                    />
                </TableCell>
                <TableCell>
                    <Checkbox
                        disabled={disabled || isFieldRequired}
                        checked={!!useForRegistration}
                        onChange={() => updateGuestField('useForRegistration', !useForRegistration)}
                    />
                    {boolOperationError && (
                        <Tooltip title="This field is required and cannot be optional during registration.">
                            <IconButton>
                                <ErrorIcon color="error" />
                            </IconButton>
                        </Tooltip>
                    )}
                </TableCell>
            </TableRow>
        </>
    );
};

export default GuestField;
